









export class ExportError extends Error {





  constructor(message, options) {
    super(message, { cause: options.cause });
    this.name = "ExportError";
    this.phase = options.phase;
    this.isTransient = options.isTransient ?? false;
    this.exportId = options.exportId;
    this.attempt = options.attempt;
  }
}

export class ExportTimeoutError extends ExportError {
  constructor(phase, exportId) {
    super(`Export timed out during ${phase}`, {
      phase,
      isTransient: true,
      exportId
    });
    this.name = "ExportTimeoutError";
  }
}

export class ExportDuplicateError extends ExportError {
  constructor(exportId, contentKey) {
    super(
      contentKey ?
      `Export already in progress for "${contentKey}"` :
      "Export already in progress",
      { phase: "validation", isTransient: false, exportId }
    );
    this.name = "ExportDuplicateError";
  }
}

export function normalizeExportError(
error,
phase,
exportId,
attempt)
{
  if (error instanceof ExportError) {
    return error;
  }

  const message = error instanceof Error ? error.message : "Export failed";
  return new ExportError(message, {
    phase,
    isTransient: false,
    exportId,
    attempt,
    cause: error
  });
}